<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-card class="delClass" header="Received">

        <Modal
        size="lg"
        title="Choose location"
        class="modal-primary backlogCities"
        v-model="modalView"
        @on-ok="modalView = false"
        :transfer="false"
      >
        <b-form-input
            style="display:inline-block; width:250px;"
            v-model="searchQuery"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>

          <hr />
          <div style="height: 400px; padding-top: 150px" v-if="!dataReady" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-row v-else style="padding:2em;">
            <template v-for="location in filterItems(locations)">
              <b-col lg="4" sm="6" :key="location.id" style="padding: 5px;">
                <a
                  class="locationLabels"
                  style="font-size:1.2em;"
                  :href="'#/base/city/?loc=' + location.id + '&city=' + location.location + '&lat=' + location.lat + '&lng=' + location.lng"
                  v-b-tooltip.hover
                  :title="location.id + ' - ' + location.contact"
                >{{location.location }} ({{location.backlog}})</a>
              </b-col>
            </template>
          </b-row>
        </Modal>

        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">Active Backlog</h5>
           <b-button
              v-if="details == 1"
              @click="detailView"
              class="btn-outline btn-sm ml-3"
              variant="outline-primary"
              right
            >
              Back
            </b-button>

          <div class="card-header-actions">
            <b-button
              class="btn"
              style="height: 26px; width: 26px"
              variant="transparent p-0"
              attr="pdf"
              @click="downloadAll()"
            >
              <i class="fa fa-download" style="color: rgb(32, 168, 216);" aria-hidden="true"></i>
            </b-button>
           <b-button
              @click="toggleFullScreen"
              style="height: 26px; width: 26px"
              ref="fsBtn"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button>
            <b-button
              class="btn"
              style="height: 26px; width: 26px"
              variant="transparent p-0"
              attr="pdf"
              @click="downloadPDF()"
            >
              <i class="fa fa-file-pdf-o" style="color: rgb(32, 168, 216);" aria-hidden="true"></i>
            </b-button>
          </div>
        </div>

        <div class="chart-wrapper">

          <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <highcharts
            ref="backRef"
            v-else-if="(!loadingData) && (changeChart == false)"
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
          <ChartModels v-else-if="changeChart == true"></ChartModels>
        </div>
        <div slot="footer">
          <b-button
            :disabled="!showAll"
            class="btn-outline"
            v-if="changeChart == false"
            variant="outline-primary"
            left
            @click="showAll = false, fetchData()"
          >Top 10</b-button>

          <b-button
            :disabled="showAll"
            class="btn-outline float-right"
            v-if="changeChart == false"
            variant="outline-primary"
            right
            @click="showAll = true, fetchData()"
          >All Data</b-button>

          <b-button
            class="btn-outline float-right"
            style="margin-right: 10px"
            variant="outline-primary"
            right
            @click="showTableAll()"
          >Table View All Data</b-button>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../router";
import { Switch as cSwitch } from "@coreui/vue";
import ModalBacklog from "./chart/addons/Modal-Backlog";
import ChartModels from "./ProductModel-Column-Three";

export default {
  name: "ActiveBacklog-Stacked",
  components: {
    router,
    highcharts: Chart,
    cSwitch,
    ModalBacklog,
    ChartModels
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity"],
  data: function() {
    return {
      fullscreen: false,
      dataReady: false,
      details: 0,
      changeChart: false,
      locations: [],
      searchQuery: "",
      loadingData: false,
      showAll: false,
      modalDate: false,
      totalValue: null,
      toggleData: false,
      modalView: false,
      dateFrom: "",
      dateTo: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      chartOptions: {
        chart: {
          type: "column",
          backgroundColor: "transparent"
        },
        exporting: {
          enabled: true
        },
        title: {
          text: "",
          style: {
            color: "white",
            display: ""
          }
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          type: "category",
          labels: {
            style: {
              color: "white"
            }
          }
        },
        yAxis: {
          title: {
            text: "Percentage Of Total"
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
        },
        plotOptions: {
           series: {
            dataLabels: {
              enabled: false,
              format: "{point.name}: {point.y:.1f}%",
              color: "white",
              style: {
                textOutline: false
              }
            },
            point: {
              events: {
                click: ({ point }) => {
                    const splitedName = point.name.split('(');
                    let name = ''
                    if (splitedName.length > 2) {
                      name = splitedName[0] + '(' + splitedName[1];
                    } else {
                      name = splitedName[0];
                    }
                  let path = "Tables"
                  if (!this.$route.path.startsWith("/base")) {
                    path = "base/" + path;
                  }
                    router.push(
                      path+"/?productModel=" + name + "%287%29" +"&date_from="+this.dateFrom+"&date_to=" +this.dateTo+"&type=backlog"
                    );
                }
              }
            }
          },
        },
         series: [
          {
            name: "Model",
            colorByPoint: true,
            data: null
          }
        ]
      }
    };
  },

  watch: {
    totalValue(value) {
      var chartSeries = this.$refs.backRef.chart.series;
      var pointSum = 0;
      chartSeries.forEach(function(obj) {
        if(obj.visible == true) {
          obj.yData.forEach(function(datas) {
            pointSum += datas;
          })
        }
      })
      this.totalValue = pointSum;
      this.chartOptions.title.text = "Total units: " + this.totalValue;
    },
    fullscreen(value) {
      if (value == false) {
        this.detailView();
      }
    },
    toggleData(param) {
      var chartSeries = this.$refs.backRef.chart.series;
      chartSeries.forEach(obj => {
        if (param === "false") {
          obj.show();
        } else {
          obj.hide();
        }
      });
    }
  },

  methods: {
    showTableAll() {
      let path = "Tables";
      if (!this.$route.path.startsWith("/base")) {
        path = "base/" + path;
      }
      this.$router.push(
        "/" + path + "/?type=backlog" +
          "&date_from=" +
          this.dateFrom +
          "&date_to=" +
          this.dateTo
      );
    },
    downloadAll() {
      this.loading = true;
      let params = {};
      params = {
        xml: true
      };
      this.$http
        .get("api/aoi/tables/alldata-backlog.php", {params, responseType: "blob"})
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "ReportAllData.xlsx");
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
    },
    detailView() {
      this.$emit('detailView');
    },
    modalLocation() {
      this.$emit('modalLocation');
    },
    changeCharty() {
    if (this.changeChart == true) {
      this.changeChart = false;
    } else {
      this.changeChart = true;
    }
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".delClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;

      let params = {};
      params = {
        chartType: "backlog"
      };
      this.$http
        .get("api/aoi/charts/chart_data_aoi.php", {
          params
        })
        .then(
          res => {

             let tmp = res.data.upData;
              tmp.sort((a, b) =>
                parseFloat(a.modelTotal) > parseFloat(b.modelTotal)
                  ? -1
                  : 1
              );


              if (this.locParam == 0) {
                if (smp.length != 0) {
                  this.chartOptions.series[0].data = smp[0].data;
                }
              } else {
                if (!this.showAll) {
                  this.chartOptions.series[0].data = tmp.slice(0, 10);
                } else {
                  this.chartOptions.series[0].data = tmp;
                }
              }

             this.totalValue = res.data.totals;
             this.chartOptions.title.text = "Total units: " + res.data.totals;

            this.loadingData = false;

          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },

    fetchLocation() {
            this.$http
            .get("api/charts/locationsBacklogCount.php").then(
              res => {
                const parsedData = res.data;
                this.locations = parsedData;
                this.dataReady = true;
              },
              err => {
                console.log(err);
              });
        },
    filterItems: function(locations) {
          var app = this;
          return locations.filter(function(location) {
            let regex = new RegExp("(" + app.searchQuery + ")", "i");
            return location.location.match(regex);
          });
        },

    downloadPDF() {
        this.$refs.backRef.chart.options.title.text =
          "Active Backlog";

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style = "color: black";
      });
      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "ActiveBacklog-" + this.dateTo
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "white";
    }
  },
  mounted() {
    if (!localStorage.getItem("aoi_user")) {
      router.push("/pages/login/");
    }

    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
    }

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.fetchData();
    if (this.details == 1) {
      this.toggleFullScreen();
      this.fetchLocation();
    }
  }
};
</script>

<style scoped>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>

<style>
/* .card {
  min-height: 603px;
} */
.backlogCities .ivu-modal{
  width: 780px !important;
}
</style>
